import '../../resources/css/visual/VisualPage.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { checkTableAuth } from '../../components/common/access-auth';
import { forwardLogin } from '../../actions/login/index';
import ModalConfirm from '../../components/common/ModalConfirm';
import ModalPickGroup from '../../components/picker/ModalPickGroup';
import ModalPickDeviceList from '../../components/picker/ModalPickDeviceList';
import Loading from '../../components/common/Loading';
import { doActivePage } from '../../actions/menu/index';
import ProjectList from '../../components/visual/ProjectList';
import ModalProjectDetail from '../../components/visual/ModalProjectDetail';
import { getTabulatorHeight } from "../common/display-setting";
import { loadSiteSummary } from '../../actions/site/index';


class FloorPlanProjectPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      pageSize : 10,
      tabulatorDivHeight: 0      
    }
  }

  componentDidMount () {
    const { forwardLogin, accountRole, roleTableAuth, history, doActivePage, loadSiteSummary, authToken } = this.props;
    
    if (checkTableAuth('rf_map', accountRole, roleTableAuth, 1)) {
      doActivePage('rf_map/project');
      if (!accountRole.flagSuperAdmin){
        loadSiteSummary(authToken);
      }
      this.setState({tabulatorDivHeight: getTabulatorHeight(this.headerDiv, 80)})
    } else {
      forwardLogin("Sorry yon can't access this page.");
      history.push(window.CONFIG.WEB_ROOT + "/Login");
    }
  }

  render() {
    const { tabulatorDivHeight } = this.state;


    let monitor;
    let pageContent = <Loading loading={false}></Loading>;
    let modalDetailContent = <div className='modal-detail-empty'></div>;
    
    
    pageContent = <ProjectList tabulatorDivHeight={ tabulatorDivHeight }/>;
    modalDetailContent = <ModalProjectDetail/>;
    

    monitor = (
      <div className='area-visual'>
        <div className='area-title-bar' ref={(headerDiv) => { this.headerDiv = headerDiv }}>
          <span className='title'>Project List</span>
        </div>
        <div className="line"></div>

        <div className='area-page-content'>
          {pageContent}
        </div>
        <div className='area-modal-datail'>
          {modalDetailContent}
        </div>
        <ModalConfirm></ModalConfirm>
        <ModalPickGroup selectMultiCol={true}></ModalPickGroup>
        <ModalPickDeviceList></ModalPickDeviceList>
      </div>
    );

    return (
      <div className='area-visual-page area-page'>
        {monitor}
      </div>
    );    
  }
}

const mapStateToProps = (state, ownProps) => {
  // const { subPage } = ownProps.match.params;

  return {
    authToken: state.loginReducers.authToken,
    accountRole: state.loginReducers.accountRole,
    accountInfo: state.loginReducers.accountInfo,
    roleTableAuth: state.loginReducers.roleTableAuth,
    // subPage: subPage,
    mappingInteriorGraph: state.visualReducers.mappingInteriorGraph,
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { doActivePage, forwardLogin, loadSiteSummary }
)(FloorPlanProjectPage))
